import { useSelectionContext } from 'modules/savedViewsIndex/context';
import { selectViews } from 'modules/savedViewsIndex/redux/selectors';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { CHECKBOX_STATUS } from 'ui/checkbox';
import { GroupSelect } from 'ui/indexPages/tables/groupSelect';

type Props = {
  total: number;
};

export const GroupSelectCell: FC<React.PropsWithChildren<Props>> = ({ total }) => {
  const views = useSelector(selectViews);
  const {
    selected: selectedIds,
    deselectAll,
    selectByIds,
    deleteDataByViewId,
    setDeleteDataByViewId,
  } = useSelectionContext();

  let groupSelectStatus = CHECKBOX_STATUS.INDETERMINATE;
  if (selectedIds.length === 0) {
    groupSelectStatus = CHECKBOX_STATUS.UNCHECKED;
  } else if (selectedIds.length === total) {
    groupSelectStatus = CHECKBOX_STATUS.CHECKED;
  }

  const onSelectAll = () => {
    const newDeleteDataByViewId = views.reduce((acc, view) => {
      const { id, name, createdByEmail, isPrivate } = view;
      return { ...acc, [view.id]: { id, name, createdByEmail, isPrivate } };
    }, {});
    setDeleteDataByViewId({ ...deleteDataByViewId, ...newDeleteDataByViewId });

    const newlySelectedIds = views.map((i) => i.id);
    const uniqueIds = [...new Set([...selectedIds, ...newlySelectedIds])];
    selectByIds(uniqueIds);
  };

  return (
    <GroupSelect onSelectAll={onSelectAll} onSelectNone={deselectAll} status={groupSelectStatus} />
  );
};
